import React, { useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  FaClipboardList,
  FaTruck,
  FaCheckCircle,
  FaHandshake,
} from "react-icons/fa";
import "./TransportPage.css";
import SEO from "../SEO";

import Transportone from "../../assets/images/transportone.png";
import Transporttwo from "../../assets/images/transporttwo.png";
import Transportthree from "../../assets/images/transportfoura.png";
import Transportfour from "../../assets/images/transportfour.png";

export default function TransportPage() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  // Icons for 3 steps section
  const stepIcons = [
    <FaClipboardList key="1" />,
    <FaTruck key="2" />,
    <FaCheckCircle key="3" />,
    <FaHandshake key="4" />,
  ];

  // Get steps from translation
  const steps = t("transportPage.threeSteps.steps", { returnObjects: true });

  return (
    <div className="bg-light">
      <SEO
        title="TransCirox – Transportdienste | Alle Transportlösungen auf einen Blick"
        description="Von Kuriertransport über Möbelumzug bis hin zu Palettentransport – entdecken Sie alle Transportdienste von TransCirox."
        keywords="Transportdienste, Umzug, Kuriertransport, Palettentransport, Transportlösungen, Gütertransport"
      />
      {/* Header Section */}
      <Container className="text-center py-5" data-aos="fade-up">
        <h3 className="fw-bold text-orange mb-3">
          {t("transportPage.header.title")}
        </h3>
        <p className="mt-3 text-muted fs-5">
          {t("transportPage.header.description1")}
        </p>
        <p className="text-muted fs-5">
          {t("transportPage.header.description2")}
        </p>
        <p className="fw-bold fs-5 text-orange">
          {t("transportPage.header.callToAction")}
        </p>
      </Container>

      {/* Services Section */}
      <Container className="my-5">
        <Row className="g-4 text-center">
          {[Transportone, Transporttwo, Transportthree, Transportfour].map(
            (img, i) => (
              <Col
                xs={12}
                md={6}
                lg={3}
                key={i}
                data-aos="zoom-in"
                data-aos-delay={i * 200}
              >
                <Card className="shadow-sm border-0 rounded-4 hover-card ">
                  <Card.Body>
                    <img
                      src={img}
                      alt={t(`transportPage.services.imageAlt${i + 1}`)}
                      className="img-fluid mb-2"
                    />
                  </Card.Body>
                </Card>
              </Col>
            ),
          )}
        </Row>
      </Container>

      {/* 3 Steps Section - New Design */}
      <section className="three-steps-section py-5" data-aos="fade-up">
        <Container>
          <h3 className="text-center fw-bold mb-5">
            {t("transportPage.threeSteps.title")}
          </h3>
          <Row className="g-4 justify-content-center">
            {Array.isArray(steps) &&
              steps.map((step, index) => (
                <Col
                  xs={6}
                  sm={6}
                  md={3}
                  key={index}
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                >
                  <div className="step-card text-center shadow border-0 rounded-4   p-3 card">
                    <div className="step-icon-wrapper">
                      {stepIcons[index]}
                      <span className="step-number">{step.number}</span>
                    </div>
                    <h6>{step.title}</h6>
                    <p className="step-description">{step.description}</p>
                  </div>
                </Col>
              ))}
          </Row>
        </Container>
      </section>

      {/* Features Section */}
      {/* <Container className="my-5">
        <Row className="g-4">
          {[
            {
              title: t("transportPage.features.0.title"),
              text: t("transportPage.features.0.description"),
            },
            {
              title: t("transportPage.features.1.title"),
              text: t("transportPage.features.1.description"),
            },
            {
              title: t("transportPage.features.2.title"),
              text: t("transportPage.features.2.description"),
            },
            {
              title: t("transportPage.features.3.title"),
              text: t("transportPage.features.3.description"),
            },
          ].map((feature, i) => (
            <Col xs={12} md={6} lg={6} key={i} data-aos="fade-up" data-aos-delay={i * 200}>
              <Card className="shadow border-0 rounded-4 h-100 feature-card p-3">
                <Card.Body>
                  <h5 className="text-orange fw-bold mb-3">{feature.title}</h5>
                  <p className="text-muted">{feature.text}</p>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container> */}
    </div>
  );
}
